// break point用。値はsrc/assets/style/val.scssを参考
const PLATFORM_CONST = {
  SP_BREAK_POINT: 480,
  PC_BREAK_POINT: 1024,
} as const

export default PLATFORM_CONST
